/**
 * @generated SignedSource<<cf3b9e4e380e83342c1349b5e4a0553d>>
 * @relayHash ed3967cb90b937fbd10d0d9c11914dc8
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-finding/539.0.0-2025-12-10T22:27:54.176Z/followSellerMutation

import { ConcreteRequest } from 'relay-runtime';
export type FavoriteSellerInput = {
  clientMutationId?: string | null;
  favoriteId?: string | null;
  sellerPk: string;
  userId: string;
};
export type followSellerMutation$variables = {
  input: FavoriteSellerInput;
  userId: string;
};
export type followSellerMutation$data = {
  readonly favoriteSeller: {
    readonly seller: {
      readonly favoritesByUser: ReadonlyArray<{
        readonly serviceId: string | null;
      } | null> | null;
    } | null;
  } | null;
};
export type followSellerMutation = {
  response: followSellerMutation$data;
  variables: followSellerMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "userIds",
    "variableName": "userId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "followSellerMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "FavoriteSellerPayload",
        "kind": "LinkedField",
        "name": "favoriteSeller",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Seller",
            "kind": "LinkedField",
            "name": "seller",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "Favorite",
                "kind": "LinkedField",
                "name": "favoritesByUser",
                "plural": true,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "followSellerMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "FavoriteSellerPayload",
        "kind": "LinkedField",
        "name": "favoriteSeller",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Seller",
            "kind": "LinkedField",
            "name": "seller",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "Favorite",
                "kind": "LinkedField",
                "name": "favoritesByUser",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-finding/539.0.0-2025-12-10T22:27:54.176Z/followSellerMutation",
    "metadata": {},
    "name": "followSellerMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "82627a71426b901bd00f06aa03a6116c";

export default node;
